/**
 * Created by hp on 2017/8/31.
 */
import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import {
    Button,
    Tab,
    TabBody,
    NavBar,
    NavBarItem,
} from 'react-weui';
import {Page} from '../components';
import {WKPreload} from '../components/wk';
import {renderMoney, isNumeric, isLZWKAPP} from '../utils';
import '../css/page/WithdrawApplyPage.css';
import lzwkQrcode from '../images/qrcode-lizhiweike.jpg';


class WithdrawApplyPage extends Component {
    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleMoneyChange = this.handleMoneyChange.bind(this);
        this.handleAlipayChange = this.handleAlipayChange.bind(this);
        this.handleShowFocusDialog = this.handleShowFocusDialog.bind(this);
        this.state = {
            initialized: false,
            data: {},
            name: '',
            alipay_account: '',
            money: 0,
            canApply: true,
            applyText: '申请提现',
            tab: 0
        }
    }

    componentDidMount() {
        axios.get(`/api/wallet/withdraw/init`).then((res) => {
            if (res.data.code === 0) {
                let currentHour = new Date().getHours();
                if (currentHour >= 0 && currentHour < 8) {
                    this.setState({
                        initialized: true,
                        data: res.data.data,
                        canApply: false,
                        applyText: '0-8点系统升级 暂停提现'
                    });
                } else if (res.data.data.can_withdraw_fee < 200) {
                    this.setState({
                        initialized: true,
                        data: res.data.data,
                        canApply: false,
                        applyText: '不可提现'
                    });
                } else {
                    this.setState({
                        initialized: true,
                        data: res.data.data,
                        tab: isLZWKAPP() ? 1 : 0
                    });
                }


            }
        });
    }

    componentWillReceiveProps(nextProps) {
        const {account} = nextProps
        // 判断是否关注公众号
        if (account && typeof (account.subscribed) !== 'undefined' && !account.subscribed) {
            this.handleShowFocusDialog();
        }
    }

    handleShowFocusDialog() {
        let text = () => (
            <div>
                <p className="text-center">提现通过公众号发放</p>
                <p className="text-center" style={{marginBottom: "10px"}}>请先关注公众号</p>
                {isLZWKAPP() ?
                    <p className="text-center" style={{fontSize: "13px",color: "#666"}}>请前往微信搜索公众号“荔枝微课”并关注</p>
                    :
                    <img src={lzwkQrcode} alt='荔枝微课'/>
                }
            </div>
        );
        this.page.showAlert(text());
    }

    verifyAccount() {
        return axios.get('/api/account/is_realname_verified')
    }

    handleSubmit() {
        const {account} = this.props;
        let {name, money, data, alipay_account} = this.state;
        let fee = renderMoney(data.can_withdraw_fee);

        // 判断是否关注公众号
        if (!account.subscribed) {
            this.handleShowFocusDialog();
            return false;
        }

        // 校验金额
        money = parseFloat(money);
        if (!isNumeric(money)) {
            this.page.showAlert('请输入有效数字');
            return false;
        }
        if (money < 2) {
            this.page.showAlert('提现金额必须大于等于2');
            return false;
        }
        if (money > 50000 && this.state.tab === 0) {
            this.page.showAlert('提现金额必须小于等于50000');
            return false;
        }
        if (money > 50000 && this.state.tab === 1) {
            this.page.showAlert('提现金额超过限制');
            return false;
        }
        if (money > fee) {
            this.page.showAlert('提现金额超过可提现金额');
            return false;
        }

        // 校验姓名
        if (name.length === 0) {
            this.page.showAlert("请输入您的真实姓名");
            return false;
        }
        if (name.length > 20) {
            this.page.showAlert("姓名不能超过二十个字");
            return false;
        }

        // 校验支付宝账号
        if (alipay_account.length === 0 && this.state.tab === 1){
            this.page.showAlert("请输入您的支付宝账号");
            return false;
        }

        this.page.showLoading();

        if (this.state.tab === 0){
            this.verifyAccount().then(res => {
                if (res.data.data.status !== 0) {
                    if (res.data.data.status === 1) {
                        this.page.showConfirm('', res.data.data.desc, () => location.assign('/liveroom/create/guide'))
                    }
                    if (res.data.data.status === 2) {
                        this.page.showConfirm('', res.data.data.desc, () => location.assign(`/liveroom/${res.data.data.liveroom_id}/verify?fr=withdraw`))
                    }
                } else {
                    axios.post(`/api/wallet/withdraw/apply`, qs.stringify({money, real_name: name})).then(res => {
                        this.page.hideLoading();
                        if (res.data.code === 0) {
                            this.page.showAlert(
                                <span>提现申请已提交，<span style={{color: 'red'}}>24小时</span>内完成审核。审核通过后，将转入您的微信零钱，请注意查收</span>,
                                () => {
                                    window.location = '/wallet/withdraw_apply_record';
                                }
                            );
                        } else {
                            if (res.data.msg.includes('前往支付宝')) {
                                this.setState({ tab: 1 })
                            }
                            this.page.showAlert(res.data.msg);
                        }
                    });
                }
            })
        }else {
            this.verifyAccount().then(res => {
                if (res.data.data.status !== 0) {
                    if (res.data.data.status === 1) {
                        this.page.showConfirm('', res.data.data.desc, () => location.assign('/liveroom/create/guide'))
                    }
                    if (res.data.data.status === 2) {
                        this.page.showConfirm('', res.data.data.desc, () => location.assign(`/liveroom/${res.data.data.liveroom_id}/verify?fr=withdraw`))
                    }
                } else {
                    let payData = new FormData();
                    payData.append('money', money);
                    payData.append('withdraw_channel', 'alipay');
                    payData.append('real_name', name);
                    payData.append('ali_account', alipay_account);
                    axios.post(`/api/wallet/withdraw/apply`, payData).then(res => {
                        this.page.hideLoading();
                        if (res.data.code === 0) {
                            this.page.showAlert(
                                <span>提现申请已提交，<span style={{color: 'red'}}>24小时</span>内完成审核。审核通过后，将转入您的支付宝账户，请注意查收</span>,
                              () => {
                                  window.location = '/wallet/withdraw_apply_record';
                              }
                            );
                        } else {
                            this.page.showAlert(res.data.msg);
                        }
                    });
                }
            })
        }

    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleMoneyChange(e) {
        this.setState({money: e.target.value});
    }

    handleAlipayChange(e) {
        this.setState({alipay_account: e.target.value});
    }

    render() {
        const {initialized, data, canApply, applyText} = this.state;

        if (!initialized) {
            return <Page parent={this}>
                        <WKPreload/>
                    </Page>
        }

        return (
            <Page parent={this} className="withdraw-apply-page">
                <div className="wk-inner-page">
                    <div className="top-bar">
                        提现申请
                        <a className="apply-record" href="/wallet/withdraw_apply_record">记录</a>
                    </div>

                    <Tab>
                        <div className="wk-tab">
                            <NavBar className="wk-tab-navbar">
                                <NavBarItem className="wk-tab-navbar-item"
                                    active={this.state.tab === 0} onClick={e=>this.setState({tab:0})}>微信提现</NavBarItem>
                                <NavBarItem className="wk-tab-navbar-item"
                                    active={this.state.tab === 1} onClick={e=>this.setState({tab:1})}>支付宝提现</NavBarItem>
                            </NavBar>
                        </div>
                        <TabBody>
                            <div style={{display: this.state.tab === 0 ? null : 'none'}}>
                                <div className="apply-money wk-border-line-before wk-border-line-after">
                                    <p className="title">可提现金额</p>
                                    <p className="content"><span className="money">{renderMoney(data.can_withdraw_fee)}</span>元</p>

                                    {data.freeze_fee > 0 &&
                                    <div className="freeze-fee wk-border-line-before">
                                        <div className="fee-title">
                                            <span className="fl">待结算金额</span>
                                            <span className="fr">{renderMoney(data.freeze_fee)}元</span>
                                        </div>
                                        <p className="fee-tips">
                                           为保障用户权益，所有课程产生的收益计入待结算金额。<br/>
                                           单课：收益在完成授课及学员购买3天后计入可提现金额；<br/>
                                           专栏：收益在学员购买7天后计入可提现金额。
                                        </p>
                                    </div>
                                    }
                                </div>

                                <div className="apply-content">
                                    <div className="apply-input">
                                        <p>提现金额</p>
                                        <input type="number" min="1" placeholder="最小提现金额为2元" onChange={this.handleMoneyChange}/>
                                    </div>

                                    <div className="apply-input">
                                        <p>收款方实名</p>
                                        <input type="text" placeholder="请输入您微信实名认证的真实姓名" onChange={this.handleNameChange}/>
                                    </div>

                                    <div className="apply-tips">
                                        <p>1. 每笔提现金额<span style={{color:'red'}}>至少2元</span>，微信官方收取<span style={{color:'red'}}>0.6%</span>手续费，
                                            <a className="detail"
                                               href="http://kf.qq.com/faq/140225MveaUz1501077rEfqI.html">详情点此查看</a>
                                        </p>
                                        <p>2. 每日账户提现上限为<span style={{color:'red'}}>5万元</span>，超出请联系客服</p>
                                        <p>3. 为保证您的资金安全，提现申请需<span style={{color:'red'}}>实名认证</span></p>
                                        <p>4. 提现申请平台处理后，将直接转入您的<span style={{color:'red'}}>微信钱包</span></p>
                                        <p>5. 0-8点是系统升级时间，暂时关闭提现功能</p>
                                        <p>6. 如需帮助请联系客服（<a href="/activity/servicepage/">客服通道</a>）</p>
                                    </div>

                                    {canApply ?
                                        <Button onClick={this.handleSubmit}>{applyText}</Button>
                                        :
                                        <Button disabled>{applyText}</Button>
                                    }
                                </div>
                            </div>

                            <div style={{display: this.state.tab === 1 ? null : 'none'}}>
                                <div className="apply-money wk-border-line-before wk-border-line-after">
                                    <p className="title">可提现金额</p>
                                    <p className="content"><span className="money">{renderMoney(data.can_withdraw_fee)}</span>元</p>

                                    {data.freeze_fee > 0 &&
                                    <div className="freeze-fee wk-border-line-before">
                                        <div className="fee-title">
                                            <span className="fl">待结算金额</span>
                                            <span className="fr">{renderMoney(data.freeze_fee)}元</span>
                                        </div>
                                        <p className="fee-tips">
                                           为保障用户权益，所有课程产生的收益计入待结算金额。<br/>
                                           单课：收益在完成授课及学员购买3天后计入可提现金额；<br/>
                                           专栏：收益在学员购买7天后计入可提现金额。
                                        </p>
                                    </div>
                                    }
                                </div>

                                <div className="apply-content">
                                    <div className="apply-input">
                                        <p>提现金额</p>
                                        <input type="number" min="1" placeholder="最小提现金额为2元" onChange={this.handleMoneyChange}/>
                                    </div>

                                    <div className="apply-input">
                                        <p>收款方实名</p>
                                        <input type="text" placeholder="请输入您支付宝实名认证的真实姓名" onChange={this.handleNameChange}/>
                                    </div>

                                    <div className="apply-input">
                                        <p>支付宝账号</p>
                                        <input type="text" placeholder="手机号/邮箱" onChange={this.handleAlipayChange}/>
                                    </div>

                                    <div className="apply-tips">
                                        <p>1. 每笔提现金额<span style={{color:'red'}}>至少2元</span>，支付宝官方收取<span style={{color:'red'}}>0.6%</span>手续费</p>
                                        <p>2. 每日个人账户提现上限为<span style={{color:'red'}}>5万元</span>，企业账户提现上限为<span style={{color:'red'}}>10万元</span>，超出请联系客服</p>
                                        <p>3. 为保证您的资金安全，提现申请需实名认证</p>
                                        <p>4. 提现申请平台处理后，将直接转入您支付宝账户</p>
                                        <p>5. 0-8点是系统升级时间，暂时关闭提现功能</p>
                                        <p>6. 如需帮助请联系客服（<a href="/activity/servicepage/">客服通道</a>）</p>
                                    </div>

                                    {canApply ?
                                        <Button onClick={this.handleSubmit}>{applyText}</Button>
                                        :
                                        <Button disabled>{applyText}</Button>
                                    }
                                </div>
                            </div>
                        </TabBody>
                    </Tab>

                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    account: state.account,
}))(WithdrawApplyPage)



// WEBPACK FOOTER //
// ./src/pages/WithdrawApplyPage.js